import React from "react";
import TeamMateCard from "./teamMateCard";

const OurTeam = () => {
  return (
    <section className="our-team-wrapper revamp-about section-padding section-bg">
        <div className="container">
            <div className="row align-items-center mb-40">
                <div className="col-12 col-md-6">
                    <div className="section-title">
                        <span className="revamp-section-badge">Our Team</span>
                        <h1 className="revamp-section-title">Meet the Team</h1>
                    </div>
                </div>
            </div>

            <div className="team-members-list row">

                <TeamMateCard classStyle={"single-team-member active"} bgImgUrl={'assets/img/team/tg.jpeg'} imagePosition={"center 20%"} name={"Thankgod M. Kalu"} role={"CEO"} />

                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team10.webp'} name={"Mario Enyinnia"} role={"CTO"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team9.webp'} name={"Nwajamma Jigo"} role={"Marketing Lead"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/roma.jpeg'} name={"Ike Romanus"} role={"Finance & Strategy"} />

                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team4.webp'} name={"Chijioke Daniel"} role={"Full-Stack Developer"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team5.webp'} name={"Victor Jonah"} role={"Software Developer"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team13.webp'} name={"Lucky Ekezie"} role={"Product Designer"} />


                {/* <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team2.webp'} name="Chibueze Obasi" role={"Project Manager"} /> */}

                {/* <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/team7.webp'} name={"Okeh Margret"} role={"UI/UX Designer"} /> */}
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/img/team/augustus.jpeg'} name={"Shaminga Augustus"} role={"Software Enigineer"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'https://res.cloudinary.com/dv62ty87r/image/upload/v1772045292/jesse_liljmu.jpg'} name={"Chidi-Nnorom Jesse"} role={"Software Developer"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/new-images/dera.jpeg'} name={"Chidera C. Ndulewo"} role={"Software Developer"} />
                <TeamMateCard classStyle={"single-team-member"} bgImgUrl={'assets/new-images/angel.jpeg'} name={"Angel"} role={"Software Developer"} />

            </div>
        </div>
    </section>
  );
};

export default OurTeam;
